// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__JJ2ae","total":"Cart_total__3nAqq","actions":"Cart_actions__BrXbX","button--alt":"Cart_button--alt__mDxus","button":"Cart_button__K-KFC"};